import { render, staticRenderFns } from "./CardIeaCategory.vue?vue&type=template&id=06c731c4&scoped=true"
import script from "./CardIeaCategory.vue?vue&type=script&lang=js"
export * from "./CardIeaCategory.vue?vue&type=script&lang=js"
import style0 from "./CardIeaCategory.vue?vue&type=style&index=0&id=06c731c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c731c4",
  null
  
)

export default component.exports